<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Edit Checklist Item'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="field-bottom-padding">
            <tidy-auto-complete
              [label]="'To-Do'"
              formControlName="title"
              [options]="toDoAutoComplete"
              [form]="form.controls.title"
              [icon]="'assets/svg/list.svg'"
              [isToSearchBetweenOptions]="true"
              [submitted]="submitted"
              [errorMessage]="'Please enter the name of the To-Do'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-textarea
              [label]="'Details (optional)'"
              formControlName="note"
              [form]="form.controls.note"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/time.svg'"
              [label]="'Estimated Time'"
              [form]="form.controls.time"
              formControlName="time"
              [items]="estimatedTimes" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-checkbox
              [(checked)]="important"
              [items]="[{viewValue: 'Mark as Important', value: false}]"
              [initValue]="important" />
            <tidy-text
              class="link"
              [body]="'Add Photos'"
              (action)="takePhotos()" />
          </tidy-row>
          <photo-caption
            [photoUrls]="photoNotesUrls"
            [type]="'task'"
            (deletePhoto)="maskImageAsDeleted($event)" />
          <tidy-row class="extra-top-padding extra-bottom-padding">
            <tidy-text
              [header]="'Associate Item (Optional)'" />
          </tidy-row>
          @if (roomObjectsItems?.length == 1) {
            <tidy-row>
              <tidy-text
                [helper]="'You haven\'t added items. You can add items to associate with To-Dos, track maintenance & more'" /><span>&nbsp;</span>
                <tidy-text
                  [actionBody]="'here'"
                  (action)="goToAddressPage()"
                  class="link" />
                <tidy-text
                  [helper]="'.'" />
              </tidy-row>
            }
            @if (roomObjectsItems?.length == 1 && numberOfRequiredObjects == 0) {
              <tidy-row>
                <tidy-text
                  [helper]="'No items added.'" />
              </tidy-row>
            }
            @if (roomObjectsItems?.length == 1 && numberOfRequiredObjects > 0) {
              <tidy-text
                [helper]="'No items added. Please add an item before adding this custom field.'" /><span>&nbsp;</span>
                <tidy-text
                  [actionBody]="'View Property'"
                  (action)="goToAddressPage()"
                  class="link" />
              }
              @if (roomObjectsItems?.length > 1) {
                <tidy-row>
                  <tidy-radio-button
                    formControlName="roomObject"
                    [form]="form.controls.roomObject"
                    [items]="roomObjectsItems"
                    (optionChange)="selectRoomObject($event)" />
                </tidy-row>
              }
              @if (selectedRoomObject) {
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [header]="'Track Inventory'" />
                </tidy-row>
                @if (selectedRoomObject?.min_quantity && hasCountFieldAdded) {
                  <tidy-row>
                    <tidy-text
                      [body]="'We create low stock alerts if the current quantity goes below'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="selectedRoomObject?.min_quantity" /><span>&nbsp;</span>
                        <tidy-text
                          [actionBody]="'add a custom count field'"
                          (action)="addCustomCountField()"
                          class="link" />
                        <tidy-text
                          [body]="'.'" />
                      </tidy-row>
                    }
                    @if (selectedRoomObject?.min_quantity && !hasCountFieldAdded) {
                      <tidy-row>
                        <tidy-text
                          [body]="'We create low stock alerts if the current quantity goes below'" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="selectedRoomObject?.min_quantity" />
                          <tidy-text
                            [body]="'. To have pros update the current inventory,'" /><span>&nbsp;</span>
                            <tidy-text
                              [actionBody]="'add a custom count field'"
                              (action)="addCustomCountField()"
                              class="link" />
                            <tidy-text
                              [body]="'.'" />
                          </tidy-row>
                        }
                        @if (!selectedRoomObject?.min_quantity) {
                          <tidy-row>
                            <tidy-text
                              [body]="'You don\'t have inventory tracking set up for this item. If you want pros update the current inventory, add a minimum quantity + current quantity to the room item in this property.'" /><span>&nbsp;</span>
                              <tidy-text
                                [actionBody]="'View Property'"
                                (action)="goToAddressPage()"
                                class="link" />
                            </tidy-row>
                          }
                        }
                      </form>
                    </tidy-card>
                    @if (!isAddingCustomFields) {
                      <tidy-row [align]="'center'">
                        <tidy-text
                          [actionBody]="'Add Custom Field'"
                          class="link"
                          (action)="expandFields()" />
                      </tidy-row>
                    }
                    @if (isAddingCustomFields) {
                      <tidy-row [alignLastItemRight]="true" style="margin-bottom: 5px">
                        <tidy-text
                          [header]="'Custom Fields'" />
                        <tidy-text
                          [actionBody]="'Add Field'"
                          class="link"
                          (action)="addCustomField()" />
                      </tidy-row>
                      @if (customFieldForm?.length) {
                        <tidy-row>
                          <tidy-text
                            [body]="'Your pro will be asked to fill out the following fields. Need help?'" /><span>&nbsp;</span>
                            <tidy-text
                              [actionBody]="'Contact Concierge'"
                              class="link"
                              (action)="goToContactConciergePage()" />
                          </tidy-row>
                        }
                      }
                      @for (customForm of customFieldForm; track customForm; let i = $index) {
                        <tidy-card>
                          <form [formGroup]="customFieldForm[i].form">
                            <tidy-row class="extra-bottom-padding">
                              <tidy-input
                                [label]="('Field Label (what should the pro do?)' | translate) + (customForm?.maxLength ? '*' : '')"
                                formControlName="label"
                                [form]="customForm.form.controls.label"
                                [icon]="'assets/svg/create.svg'"
                                [customMask]="customForm?.maxLength ? { maxLenghth: customForm.maxLength } : null"
                                [submitted]="submitted"
                                [errorMessage]="'Please enter a label.'" />
                            </tidy-row>
                            @if (customForm?.maxLength) {
                              <tidy-row class="extra-bottom-padding" style="margin-top: -15px">
                                <tidy-text
                                  [smallHelper]="'*40 character max label length for this field type'" />
                              </tidy-row>
                            }
                            <tidy-row>
                              <tidy-select
                                [icon]="'assets/svg/list.svg'"
                                [label]="'Field Type'"
                                [form]="customForm.form.controls.type"
                                formControlName="type"
                                [items]="customFieldTypeItems"
                                (optionChange)="selectFieldType($event, i)"
                                [submitted]="submitted"
                                [errorMessage]="'Please select a field type.'" />
                            </tidy-row>
                            @if (customForm.form.value.type) {
                              <tidy-row>
                                <tidy-checkbox
                                  [items]="[{viewValue: 'Make this required for the pro', value: true}]"
                                  (click)="selectRequired(customForm, customForm.form.value.required)"
                                  [initValue]="customForm.form.value.required" />
                              </tidy-row>
                            }
                            @if (customForm.numberOfRequiredOptions > 0) {
                              <tidy-row [alignLastItemRight]="true">
                                <tidy-text
                                  [header]="'Options'"
                                  style="margin-right: 5px" />
                                <tidy-text
                                  [actionBody]="'Add Option'"
                                  class="link"
                                  (action)="addOption(i)" />
                              </tidy-row>
                              @for (option of customForm.options; track option; let index = $index) {
                                <tidy-row>
                                  <tidy-text
                                    [body]="('Option ' | translate) + ((index | translate) + (1 | translate))"
                                    style="margin-right: 5px" />
                                  <tidy-text
                                    [actionBody]="'X'"
                                    class="link"
                                    (action)="removeOption(i, index)" />
                                </tidy-row>
                                <tidy-row>
                                  <form [formGroup]="customFieldForm[i].options[index]">
                                    <tidy-input
                                      [label]="('Option ' | translate) + ((index | translate) + (1 | translate)) + (' Label' | translate)"
                                      formControlName="option"
                                      [form]="customFieldForm[i].options[index].controls.option"
                                      [icon]="'assets/svg/create.svg'"
                                      [submitted]="submitted"
                                      [errorMessage]="'Please enter a label.'" />
                                  </form>
                                </tidy-row>
                                @if (customForm.options[index].hasCommaError) {
                                  <tidy-row style="margin-top: -5px">
                                    <tidy-error-message
                                      [text]="'Please remove any commas from the option label.'" />
                                  </tidy-row>
                                }
                              }
                              @if (customForm.options.length == 0) {
                                <tidy-row class="extra-bottom-padding">
                                  <tidy-text
                                    [helper]="('None Added - Add at Least ' | translate) + customForm.numberOfRequiredOptions" />
                                </tidy-row>
                              }
                              @if (submitted && (customForm.options.length < customForm.numberOfRequiredOptions)) {
                                <tidy-row class="extra-bottom-padding">
                                  <tidy-error-message
                                    [text]="('Please add at least ' | translate) + customForm.numberOfRequiredOptions + (' option' | translate) + (customForm.numberOfRequiredOptions == 1 ? '' : ('s' | translate))" />
                                </tidy-row>
                              }
                            }
                          </form>
                          <tidy-row class="extra-top-padding extra-bottom-padding">
                            <tidy-divider />
                          </tidy-row>
                          <tidy-row [alignLastItemRight]="true">
                            <tidy-text
                              [actionBody]="'Remove Field'"
                              class="link"
                              (action)="removeField(i)" />
                          </tidy-row>
                        </tidy-card>
                      }
                      @if (isAddingCustomFields) {
                        <tidy-row [align]="'center'" class="extra-bottom-padding">
                          <tidy-text
                            [actionBody]="'Add Field'"
                            class="link"
                            (action)="addCustomField()" />
                        </tidy-row>
                      }
                      @if (errorMessage?.length) {
                        <tidy-error-message
                          [text]="errorMessage" />
                      }
                      <tidy-button
                        [text]="'Save Changes'"
                        [action]="boundSaveChanges"
                        class="primary" />
                      <tidy-row [align]="'center'">
                        <tidy-text
                          [body]="'Delete To-Do'"
                          (action)="deleteToDo()"
                          class="link red" />
                      </tidy-row>
                    }
                  </tidy-wrapper>
                </ng-template>

                @if (!isRightSideContent) {
                  <app-scroll-wrapper [templateContent]="content" />
                }

                @if (isRightSideContent) {
                  <ion-content class="ion-content-right-column">
                    <ng-container *ngTemplateOutlet="content" />
                  </ion-content>
                }
